import { UserProfileFormDTO } from 'interfaces/users/users'

export const getUserProfileFormPayload = ({ values }: { values: UserProfileFormDTO }): UserProfileFormDTO => ({
  firstName: values.firstName,
  lastName: values.lastName,
  email: values.email,
})
